import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { onLinkClick } from './Link';
import { on } from './Root';
import { scopeLinksContainerAttribute, clickedLink } from './history';
export default class LinksContainer extends React.Component {
    componentDidMount() {
        const node = ReactDOM.findDOMNode(this);
        node.setAttribute(scopeLinksContainerAttribute, 'true');
        this.unbindClicks = on('click', e => {
            const event = e;
            const link = clickedLink(event.nativeEvent);
            if (link && !event.isDefaultPrevented() && isChildOf(link, node)) {
                onLinkClick(link, event);
            }
        });
    }
    componentWillUnmount() {
        if (this.unbindClicks) {
            this.unbindClicks();
        }
    }
    render() {
        return React.Children.only(this.props.children);
    }
}
function isChildOf(child, parent) {
    let current = child;
    while (current) {
        if (current === parent) {
            return true;
        }
        current = current.parentElement;
    }
    return false;
}
